enum Sites {
  English = 'english',
  Norwegian = 'norwegian',
}

enum ContentSections {
  NewsNo = 'nyheter',
  NewsEn = 'news',
  StudentUnions = 'studentUnions',
}

enum SinglesNo {
  StudentUnions = 'studentforeninger',
  Eateries = 'spisesteder',
  News = 'nyheter',
}

enum ContentCategories {
  Eatery = 'eatery',
  Campus = 'campus',
  Topic = 'topic',
}

enum EntryTypes {
  Eatery = 'eatery',
  Pages = 'pages',
  List = 'list',
  Offer = 'offer',
  Service = 'service',
  NewsList = 'newsList',
}

enum BlockTypes {
  RichText = 'richText',
  Callout = 'callout',
  DescriptionList = 'descriptionList',
  SymbolList = 'symbolList',
  Images = 'images',
  Embed = 'embed',
  Downloads = 'downloads',
  Persons = 'persons',
  Map = 'map',
  CallToAction = 'callToAction',
  Accordion = 'accordion',
  InfoBox = 'infoBox',
  Promotional = 'promotional',
}

enum Services {
  Health = 'Helse',
  StudentLife = 'Studentliv',
  FoodAndBeverage = 'Mat og drikke',
  Housing = 'Bolig',
  Childcare = 'Barnehager',
  Training = 'Trening',
  UnknownService = 'Ukjent tjeneste',
}

enum FavoriteTypes {
  Campuses = 'campuses',
  Restaurants = 'restaurants',
  Persons = 'persons',
  Homes = 'homes',
  TrainingStudios = 'training_studios',
  Diets = 'diets',
}

export default {
  Sites,
  ContentSections,
  ContentCategories,
  BlockTypes,
  Services,
  SinglesNo,
  FavoriteTypes,
  EntryTypes,
}
